<script setup>
defineProps({
  header: {
    type: Object,
    required: true,
  },
});

const sortIconMap = {
  default: 'i-ri-expand-up-down-line',
  asc: 'i-ri-arrow-up-s-line',
  desc: 'i-ri-arrow-down-s-line',
};
</script>

<template>
  <span :class="sortIconMap[header.column.getIsSorted() || 'default']" />
</template>
